var React = require('react');

function ProductsIcon21Inline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Obszar_roboczy_33","data-name":"Obszar roboczy 33","transform":"translate(-3.59 -6.07)"},[React.createElement("path",{"id":"Path_349","data-name":"Path 349","d":"M13.15,15.93V34.36H36.41V15.93ZM34.11,32.06H15.45V18.23H34.11Z","key":0}),React.createElement("path",{"id":"Path_350","data-name":"Path 350","d":"M30.28,11H8.37V28.08h2.3V13.3H30.28Z","key":1}),React.createElement("path",{"id":"Path_351","data-name":"Path 351","d":"M25.5,6.07H3.59V23.15H5.88V8.37H25.5Z","key":2})]));
}

ProductsIcon21Inline.defaultProps = {"width":"32.82","height":"28.29","viewBox":"0 0 32.82 28.29"};

module.exports = ProductsIcon21Inline;

ProductsIcon21Inline.default = ProductsIcon21Inline;
